import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {toConfirmationPage, toEntryCollection} from '../lib/types/contentful'
import {toResourceConfirmationPayload} from '../lib/types/payload'
import {Box, Grid} from '@primer/react-brand'
import {ContentfulCtaBanner} from '@github-ui/swp-core/components/contentful/ContentfulCtaBanner'
import {useContentfulData} from '@github-ui/swp-core/lib/hooks/use-contentful-data'
import {BreadcrumbsList} from '../components/BreadcrumbsList/BreadcrumbsList'
import RelatedResources from '../components/RelatedResources/RelatedResources'

export const ConfirmationPage = () => {
  const {contentfulRawJsonResponse, breadcrumbLinks} = toResourceConfirmationPayload(useRoutePayload<unknown>())
  const safeResolveEnabled = isFeatureEnabled('site_safe_contentful_resolve_response')
  const contentfulData = useContentfulData(contentfulRawJsonResponse, {legacyMode: !safeResolveEnabled})
  const page = toConfirmationPage(toEntryCollection(contentfulData).at(0))
  const {template} = page.fields
  const {ctaBanner, relatedResources} = template.fields

  const breadcrumbs =
    breadcrumbLinks?.map(link => ({
      name: link.name,
      url: link.href,
    })) || []

  return (
    <>
      <Grid>
        <Grid.Column>
          {breadcrumbs.length > 0 ? (
            <Box marginBlockStart={20} marginBlockEnd={24}>
              <BreadcrumbsList items={breadcrumbs} />
            </Box>
          ) : null}

          {ctaBanner ? <ContentfulCtaBanner component={ctaBanner} /> : null}
        </Grid.Column>
      </Grid>

      {relatedResources && relatedResources.length > 0 && (
        <Grid className="tmp-mt-5 tmp-mt-lg-9 tmp-mb-5 tmp-mb-lg-10">
          <Grid.Column>
            <RelatedResources relatedResources={relatedResources} />
          </Grid.Column>
        </Grid>
      )}
    </>
  )
}
